import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const res = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'Ein Fehler ist aufgetreten');
            }

            setSuccess(true);
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    if (success) {
        return (
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="card mt-5">
                        <div className="card-body text-center p-5">
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📧</div>
                            <h4 className="card-title mb-3">E-Mail gesendet!</h4>
                            <p className="text-muted mb-4">
                                Falls ein Konto mit dieser E-Mail-Adresse existiert,
                                hast du eine E-Mail mit einem Link zum Zuruecksetzen deines Passworts erhalten.
                            </p>
                            <p className="text-muted small mb-4">
                                Der Link ist 1 Stunde gueltig. Pruefe auch deinen Spam-Ordner.
                            </p>
                            <Link to="/login" className="btn btn-primary">
                                Zurueck zum Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card mt-5">
                    <div className="card-body">
                        <h4 className="card-title mb-4">Passwort vergessen</h4>
                        <p className="text-muted mb-4">
                            Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zuruecksetzen deines Passworts.
                        </p>

                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">E-Mail-Adresse</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoFocus
                                    placeholder="deine@email.de"
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Senden...
                                    </>
                                ) : (
                                    'Link anfordern'
                                )}
                            </button>
                        </form>

                        <div className="text-center mt-4">
                            <Link to="/login" className="text-muted">
                                Zurueck zum Login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
